import * as ReactBootstrap from "react-bootstrap";
import {SliderHeaderProps} from "./types";


export const SliderHeader = ({children}: SliderHeaderProps): JSX.Element => {
    return (
        <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="12">{children}</ReactBootstrap.Col>
        </ReactBootstrap.Row>
    )
}
